<template>
    <!-- 模板 / 详情 -->
    <div>
        <myheader  :messages="parentMessage"></myheader>
        <!--  -->
        <div class="aboutopcomm aboutopcomm3 w1750 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                <div class="text">
                    <div class="h">{{goolist.title}}</div>
                    <div class="p">{{goolist.brief}}</div>
                    <div class="tot">
                        <div class="uer">
                            <div class="i">价格</div>
                            <div class="em">¥</div>
                            <div class="tt">{{goolist.jiage}}</div>
                            <!-- <div class="em">/年</div> -->
                        </div>
                        <div class="s">{{goolist.huodong}}</div>
                    </div>
                    <div class="moreboxmax moreboxmax2">
                        <div class="a a1"  @click="kefuclick">咨询购买</div> 
                        <div class="a a2 play" v-if="goolist.videourl!==''">演示</div>
                    </div>
                </div> 
                <div class="img"><img :src="goolist.backpic" alt=""></div>
            </div>
        </div>
        <div class="newsdatabox newsdatabox2 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
            <div class="textbox">
                <div class="data" v-html="goolist.content">
                    <!-- <p>{{goolist.content}}</p> -->
                </div>
                <div class="more" @click="mouldmores"></div>
            </div>  
        </div>
        <div class="nouldotherbox wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk">
                <div class="tit">其它热门模版</div>
                <div class="list">
                    <div class="li" v-for="(item,index) in moreserbox" :key="index" @click="otherclick(item.id)">
                        <div class="m"><img :src="item.pic" alt=""></div>
                        <div class="h">{{item.title}}</div>
                        <div class="p">{{item.apply}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!--  -->
        <div class="videoBoxWent">
            <div class="up"></div>
            <div class="cont">
                <div class="sole"></div>
                <video :src="goolist.videourl" controls="" loop="" id="video"></video>
            </div>
        </div>
        <!--  -->
        <myfooter></myfooter>
    </div>
</template>

<script>
    import myfooter from './footer.vue'
    import myheader from './header.vue'
    
    export default {
        data() {
            return {
				parentMessage: 1,
                goolist: [],
                moreserbox: [],
            }
        },
        created() {
            this.gooler(this.$route.query.id);
            this.getmouldindex()
        },
        methods: {
            topclick(index){
                this.num = index
            },
            async gooler(id) {
                //var url = `case/list?id=${id}`
                var url = `/api/smallapp/${id}`
                const { data: res } = await this.$http.get(url)
                
                console.log(res)
                
                this.goolist = res.data
            },
            async getmouldindex(){
                var url = `/api/smallapp/recommend`
                const { data: res } = await this.$http.post(url)
                
                console.log(res)
                this.moreserbox = res.data
                
                if(res.code !== 200){
                    return alert('获取失败！')
                }
            
            },
            otherclick(id){
                var url = `/moulddata?id=${id}`
                this.$router.push(url).catch(err=>{ })
                this.gooler(this.$route.query.id);
                window.scrollTo(0,0);
            },
            mouldmores(){
                this.$router.push('/mould').catch(err=>{ })
                window.scrollTo(0,0);
            },
			kefuclick(){
			    const url = 'https://p.qiao.baidu.com/cps4/chatIndex?siteToken=fa6b3d5361002f77431328216553694d&speedLogId=16216501944184228_1621650194418_93941&eid=25401671&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211856238%22%2C%22userId%22%3A%2225401671%22%2C%22pageId%22%3A0%7D';
			    // window.location.href = url;
			    window.open(url)
			},
        },
        components: {
        	myfooter, myheader
        }
    }
</script>

<style>
    
.videoBoxWent{ display: flex; justify-content: center; align-items: center; position: fixed; left: 0; top: 0; z-index: -60; opacity: 0; width: 100%; height: 100%;}
.videoBoxWent2{ opacity: 1; z-index: 60;}
.videoBoxWent .up{ position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: #000; z-index: 0; opacity: 0.5;}
.videoBoxWent .cont{ width: 320px; padding: 10px; background: hsla(0,0%,100%,0.50); position: relative; z-index: 5; transform: scale(0.2); opacity: 0; transition: all 0.5s;}
.videoBoxWent2 .cont{ opacity: 1; transform: scale(1);}
.videoBoxWent .cont video{ display: block; width: 100%;}
.videoBoxWent .sole{ cursor: pointer; width: 40px; height: 40px; background: url(../assets/images/sole.png) no-repeat center; background-size: 100% 100%; position: absolute; bottom: -65px; left: 50%; margin-left: -20px; transition: all 0.5s;}
.videoBoxWent .sole:hover{ transform: rotate(360deg);}

</style>
